/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S10_HeadingInputs */

const tr_kullanim_s10_heading = /** @type {(inputs: Kullanim_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Kişisel Verilerin Korunması`)
};

const en_kullanim_s10_heading = /** @type {(inputs: Kullanim_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Protection of personal data`)
};

const de_kullanim_s10_heading = /** @type {(inputs: Kullanim_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Schutz personenbezogener Daten`)
};

const ru_kullanim_s10_heading = /** @type {(inputs: Kullanim_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Защита персональных данных`)
};

/**
* | output |
* | --- |
* | "10. Protection of personal data" |
*
* @param {Kullanim_S10_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s10_heading = /** @type {((inputs?: Kullanim_S10_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S10_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s10_heading(inputs)
	if (locale === "de") return de_kullanim_s10_heading(inputs)
	if (locale === "ru") return ru_kullanim_s10_heading(inputs)
	return tr_kullanim_s10_heading(inputs)
});